import defaultFieldsData from './defaultFieldsData.json';
import { HMIField, HMITemplate } from './types';

/**
 * Seed HMI template generated from `UI_controls (1).xlsx` (sheet `UI_fields`).
 * This is what a solution engineer would author on the Asset Hierarchy
 * "HMI Configuration" tab for a BMT BlowScan style asset. It is treated
 * purely as data - the renderer has no BMT-specific code paths.
 */
export const BMT_BLOWSCAN_TEMPLATE: HMITemplate = {
  id: 'tmpl-bmt-blowscan',
  name: 'BMT BlowScan - Standard HMI',
  description:
    'Server-driven HMI generated from the BMT UI_fields specification (dashboard, settings and process screens).',
  version: 1,
  modelIds: ['dtmi:pepsico:bmt:blowscan;1'],
  pollIntervalSec: 7, // within the 5-10s BMT edge polling window
  screens: defaultFieldsData.screens,
  groups: defaultFieldsData.groups,
  fields: defaultFieldsData.fields as unknown as HMIField[],
  createdAt: '2025-01-01T00:00:00.000Z',
  updatedAt: '2025-01-01T00:00:00.000Z',
};

export const DEFAULT_TEMPLATES: HMITemplate[] = [BMT_BLOWSCAN_TEMPLATE];
